module.exports = {
  "/": {},
  "/crm": {
    "success": {
      "default": [
        "FREE_TOOLS_PAGE"
      ],
      "free tools page v2 loaded": [
        "FREE_TOOLS_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "freePage"
  },
  "/bundle": {
    "success": {
      "default": [
        "BUNDLE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "bundlePage"
  },
  "/marketing": {
    "success": {
      "default": [
        "MARKETING_PAGE"
      ],
      "marketing page v2 loaded": [
        "MARKETING_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPage"
  },
  "/sales": {
    "success": {
      "default": [
        "SALES_PAGE"
      ],
      "sales page v2 loaded": [
        "SALES_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "salesPage"
  },
  "/service": {
    "success": {
      "default": [
        "SERVICE_PAGE"
      ],
      "service page v2 loaded": [
        "SERVICE_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "servicePage"
  },
  "/cms": {
    "success": {
      "default": [
        "CMS_PAGE"
      ],
      "content page v2 loaded": [
        "CONTENT_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "cmsPage"
  },
  "/content": {
    "success": {
      "default": [
        "CMS_PAGE"
      ],
      "content page v2 loaded": [
        "CONTENT_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "contentPage"
  },
  "/data": {
    "success": {
      "default": [
        "OPERATIONS_PAGE"
      ],
      "data page v2 loaded": [
        "DATA_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "dataPage"
  },
  "/commerce": {
    "success": {
      "default": [
        "COMMERCE_PAGE"
      ],
      "commerce page v2 loaded": [
        "COMMERCE_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "commercePage"
  },
  "/suite": {
    "success": {
      "default": [
        "SUITE_PAGE"
      ],
      "customer platform page v2 loaded": [
        "CUSTOMER_PLATFORM_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "suitePage"
  },
  "/marketing-plus": {
    "success": {
      "default": [
        "MARKETING_PLUS_PAGE"
      ],
      "marketing plus page v2 loaded": [
        "MARKETING_PLUS_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPlusPage"
  },
  "/smart-crm": {
    "success": {
      "default": [
        "SMART_CRM_PAGE"
      ],
      "smart crm page v2 loaded": [
        "SMART_CRM_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "smartCrmPage"
  },
  "/marketing/:tab": {},
  "/sales/:tab": {},
  "/service/:tab": {},
  "/cms/:tab": {},
  "/content/:tab": {},
  "/data/:tab": {},
  "/suite/:tab": {},
  "/smart-crm/:tab": {},
  "/hubspot-credits": {
    "success": {
      "default": [
        "HUBSPOT_CREDITS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "hubSpotCreditsPage"
  }
};